import "./LanguageSelect.css";
import { useSelector } from "react-redux";
// import { useDispatch } from "react-redux";
// import { bindActionCreators } from "redux";
// import { actionCreators } from "../../store/index";
import { useBetween } from "use-between";

function LanguageSelect() {
  // const dispatch = useDispatch();
  // const { turnLang } = bindActionCreators(actionCreators, dispatch);
  const { locale, setLocale, setLang } = useBetween(
    useSelector((state) => state.useSharedLang)
  );

  const changeLang = (e) => {
    setLocale(e.target.value);
    setLang(e.target.value);
    // turnLang(e.target.value);
  };

  return (
    <div>
      <select
        className="selectBoxLang"
        onChange={changeLang}
        name="lang"
        value={locale}
      >
        <option className="optionsMenu" value="AR">
          العربيّة
        </option>
        <option className="optionsMenu" value="EN">
          English
        </option>
      </select>
    </div>
  );
}

export default LanguageSelect;
